// Volltext-Suche über mehrere Begriffe.
// Mehrere Suchbegriffe werden über Trennzeichen getrennt und UND-verknüpft:
// ALLE Begriffe müssen im durchsuchten Text vorkommen (grenzt die Treffer ein).
//
// Trennzeichen: Leerraum, Komma, Semikolon, Stern, Pipe, Plus.

const SEARCH_DELIMITERS = /[\s,;*|+]+/;

// Zerlegt eine Suchanfrage in einzelne, kleingeschriebene Begriffe (leere verworfen).
export const parseSearchTerms = (query) =>
  String(query || '')
    .toLowerCase()
    .split(SEARCH_DELIMITERS)
    .map((term) => term.trim())
    .filter(Boolean);

// Baut aus beliebig vielen Werten einen durchsuchbaren Text (null/undefined werden ignoriert).
export const buildSearchableText = (...values) =>
  values
    .filter((value) => value !== null && value !== undefined && value !== '')
    .join(' ')
    .toLowerCase();

// true, wenn ALLE Suchbegriffe im Text vorkommen (UND). Leere Suche => alles passt.
export const matchesAllTerms = (text, query) => {
  const terms = parseSearchTerms(query);
  if (terms.length === 0) return true;
  const haystack = String(text || '').toLowerCase();
  return terms.every((term) => haystack.includes(term));
};
